import { Box, ColorPicker as ColorPickerBase } from "@wix/design-system";
import React, { useState } from "react";
import { ColorSwatches } from "../common/color-swatches";
const ColorPicker = ({
  userColors,
  color,
  onChange,
  onNewColorAdded,
  showColorPicker: initialShowColorPicker,
  colorPickerClassName,
  showResetButton
}) => {
  const [showColorPicker, setShowColorPicker] = useState(initialShowColorPicker);
  return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", marginTop: "SP2", marginBottom: "SP2", gap: "SP2" }, /* @__PURE__ */ React.createElement(
    ColorSwatches,
    {
      userColors,
      selectedColor: color,
      onAddClick: () => setShowColorPicker(true),
      onChange,
      showResetButton
    }
  ), showColorPicker ? /* @__PURE__ */ React.createElement("div", { className: colorPickerClassName }, /* @__PURE__ */ React.createElement(
    ColorPickerBase,
    {
      value: color || userColors[0],
      showConverter: false,
      onChange: () => {
      },
      onConfirm: (color2) => {
        setShowColorPicker(false);
        const colorHex = typeof color2 === "string" ? color2 : color2.hex();
        if (!userColors.includes(colorHex)) {
          onNewColorAdded(colorHex);
        }
      },
      onCancel: () => setShowColorPicker(false)
    }
  )) : null);
};
export {
  ColorPicker
};
//# sourceMappingURL=color-picker.js.map
